import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/demand')({
  component: DemandPage,
});

function DemandPage() {
  return <Outlet />;
}
